import { toast } from "react-toastify";
import { api } from "../Configurations/axios";

//Get:
const CreateRegister = async (companyId: string, opportunityPanelId: string, bankId: string, userEmail: string) => {
    try {
        const result = await api.post(`/Register/Post`, {
            companyId: companyId,
            opportunityPanelId: opportunityPanelId,
            bankId: bankId,
            userEmail: userEmail
        });

        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllByCompany = async (companyId: string, page = 1, take = 7, word = "all") => {

    // &page={page}&take={take}&word={word}
    word = word == undefined || word == null ? "all" : word ;

    const result = await api.get(`/Register/GetAllByCompany/?companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);

    const response = await result.data;

    return response;
}
const GetAllRegisterByCompany = async (companyId: string) => {

    const result = await api.get(`/Register/GetAllRegisterByCompany/?companyId=${companyId}`);

    const response = await result.data;

    return response;
}

const GetYearByRegister = async (registerId: string) => {

    const result = await api.get(`/Register/GetYearByRegister/${registerId}`);

    const response = await result.data;

    return response;
}
const GetAllFilesPleaByPleaId = async (pleaId: string)=>{
    const result = await api.get(`/Plea/GetAllFiles?pleaId=${pleaId}`);
    const response = await result.data;
    return response
}
const DeleteFilePlea = async ( companyId: string ,fileName: string, fileId: string, pleaId: string) => {
    try {
        const data = {companyId, fileName: fileName, fileId: fileId, pleaId: pleaId };
        const result = await api.delete("/Plea/DeleteFilePlea", { data });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteRegisterAPI = async (registerId: string, companyId: string) => {
    try {
        const result = await api.delete(`/Register/DeleteRegisterById`, {data: { registerId: registerId, companyId: companyId}});
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const UploadPlea = async (file: any, url: string, userEmail: string, pleaId: string) => {
    try {

        var UploadFileDreAndBalanceCommand = new FormData();

        UploadFileDreAndBalanceCommand.append("ImageFile", file);
       

        const result = await api.post(`/Plea/PostFiletechnical?Url=${url}&userEmail=${encodeURIComponent(userEmail)}&pleaId=${pleaId}`, UploadFileDreAndBalanceCommand, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        toast.error(error);
        throw new Error(error.response.data);
    }
}
const  DownloadFileAPI = async(
    Id: String ) =>{
      try{
          const result = await api.get(
            `/Plea/DownloadFiletechnical?id=${Id}`,{
              responseType: 'blob'
          });
          const response = result.data;
          return response;
      }catch(error: any) {
          throw new Error(error.response.data);
      }
  };

export {
    UploadPlea,
    CreateRegister,
    GetAllByCompany,
    GetYearByRegister,
    GetAllFilesPleaByPleaId,
    DeleteFilePlea,
    DeleteRegisterAPI,
    GetAllRegisterByCompany,
    DownloadFileAPI
}